import Commodity from 'domain/commodity';

export default function calculateNumberOfContracts(commodity: Commodity, quantity: number, useMini: boolean): number {
    let contractSize = commodity?.contractSize ?? quantity;
    if (useMini)
        contractSize = commodity?.miniContractSize ?? quantity
    let fullContracts = Math.round(quantity / contractSize);
    return Math.max(fullContracts, 1);
}

export function isHedgeableQuantity(commodity: Commodity, quantity: number, useMini: boolean): boolean {
    let contractSize = commodity?.contractSize ?? quantity;
    if (useMini)
        contractSize = commodity?.miniContractSize ?? quantity
    return  quantity >= contractSize;
}